// @ts-nocheck
import React, { Suspense } from 'react'
import { connect } from 'react-redux'
import Actions from '../../../actions'
import Form from '..'
import { colors, sizes } from '@lmc/common/constants'
import { formatAddress } from '../../../common/utils'
import {
  AvatarUpload,
  ErrorBox,
  IconButton,
  ProfilePicture
} from '../../generic'
import Field from '../../fields'
import { isBrowser, isTablet } from 'react-device-detect'
import { history } from '../../../store'
import { Button, Icon } from '@lmc/ui-kit'

const isDesktop = isBrowser || isTablet

export class HomeEditForm extends React.Component {
  formRef = null

  constructor(props) {
    super(props)
    this.state = { imageUploadOpen: false }
  }

  setFormRef = (node) => {
    this.formRef = node
  }

  handleCancel = () => {
    const { fields, remove } = this.props
    const { id } = fields
    remove({
      onConfirm: () => history.push(`/homes/${id}/profile`)
    })
  }

  handleComplete = (resident) => {
    const { fetchList, showToast } = this.props
    showToast({ title: 'Updated a Home' })
    fetchList('homes')
    history.push(`/homes/${resident.id}/profile`)
  }

  handleImageSave = (file, imageUri) => {
    const { addFormFile } = this.props

    addFormFile({ key: 'picture', file, uri: imageUri })
  }

  handleSubmit = () => {
    const { fields, updateItem } = this.props
    updateItem({
      url: `list/homes/${fields.id}`,
      onComplete: this.handleComplete,
      onError: () => {
        if (this.formRef) {
          this.formRef?.scrollIntoView({ behavior: 'smooth' })
        }
      }
    })
  }

  renderMainContent = (fields) => (
    <div>
      <div
        className="lmc-card"
        style={{
          ...styles.sectionContainer,
          ...styles.primaryInfoContainer
        }}
      >
        {this.renderPrimaryFields(fields)}
      </div>
      <IconButton
        antdIconName="DragOutlined"
        iconStyle={styles.transferIcon}
        id="resident-transfer"
        onClick={() => {
          if (window.Intercom) window.Intercom('showNewMessage')
        }}
        style={styles.transferButton}
        text="Transfer Resident"
        type="cancel"
      />
    </div>
  )

  renderPrimaryFields = (fields) => {
    const { errors } = this.props
    return (
      <div style={styles.fieldsContainer}>
        <ErrorBox errors={errors} style={{ marginBottom: 10 }} />
        <div style={styles.formField}>
          <Suspense fallback={<div>Loading...</div>}>
            <Field
              keys="name"
              label="Name"
              formId={FORM_ID}
              type="noEditText"
              values={fields}
            />
          </Suspense>
        </div>
        <div style={styles.formField}>
          <Suspense fallback={<div>Loading...</div>}>
            <Field
              keys="address"
              label="Address"
              formId={FORM_ID}
              formatValue={formatAddress}
              type="noEditText"
              values={fields}
            />
          </Suspense>
        </div>
        <div style={styles.formField}>
          <Suspense fallback={<div>Loading...</div>}>
            <Field
              keys="telephone"
              label="Telephone"
              formId={FORM_ID}
              type="text"
              values={fields}
            />
          </Suspense>
        </div>
      </div>
    )
  }

  renderFooter = (isSubmitting) => (
    <div
      className="lmc-fixed-footer"
      style={{
        ...styles.footer
      }}
    >
      <div>
        <Button
          className="btn-edit-cancel"
          onClick={this.handleCancel}
          style={styles.cancelButton}
          variant="secondary"
          icon={<Icon name="CloseOutlined" />}
        >
          Cancel
        </Button>

        <Button
          className="btn-edit-save"
          loading={isSubmitting}
          onClick={this.handleSubmit}
          variant="primary"
          icon={<Icon name="CheckOutlined" />}
          style={styles.saveButton}
        >
          Save
        </Button>
      </div>
    </div>
  )

  render() {
    const { fields, files, isSubmitting } = this.props
    const { imageUploadOpen } = this.state

    if (!fields) return null
    const picture = files && files.picture ? files.picture.uri : fields.picture

    return (
      <div ref={this.setFormRef}>
        <div
          style={{
            ...styles.wrapper,
            paddingTop: isDesktop ? 50 : null
          }}
        >
          <ProfilePicture
            edit
            onClick={() => this.setState({ imageUploadOpen: true })}
            type="large"
            style={styles.image}
            url={picture || SITE_PLACEHOLDER}
          />
          {this.renderMainContent(fields)}
        </div>
        {this.renderFooter(isSubmitting)}
        <AvatarUpload
          customButton
          isModalOpen={imageUploadOpen}
          onSave={this.handleImageSave}
          onClose={() => this.setState({ imageUploadOpen: false })}
        />
      </div>
    )
  }
}

const SITE_PLACEHOLDER =
  'https://lmc-data-production.s3.eu-west-2.amazonaws.com/public/house_placeholder.png'
const FORM_ID = 'editHome'

const styles = {
  formField: {
    paddingTop: 20
  },
  cancelButton: {
    marginRight: 10
  },
  deleteButton: {
    background: colors.red,
    color: 'white'
  },
  dottedDivider: {
    borderBottom: '1px dashed',
    borderColor: colors.grey,
    height: 1,
    margin: 'auto',
    marginTop: 20,
    marginBottom: 20,
    width: '90%'
  },
  divider: {
    background: colors.grey,
    height: 1,
    margin: 'auto',
    marginTop: 20,
    marginBottom: 20,
    width: '90%',
    display: 'none'
  },
  image: {
    position: 'relative',
    zIndex: 1
  },
  fieldsContainer: {
    display: 'flex',
    flexDirection: 'column',
    margin: '0 auto',
    minWidth: '60%',
    width: isBrowser || isTablet ? '60%' : '100%'
  },
  footer: {
    display: 'flex',
    justifyContent: 'flex-end',
    width: isBrowser || isTablet ? 'calc(100vw - 290px)' : '100vw'
  },
  iconContainer: {
    alignItems: 'center',
    borderRadius: 4,
    display: 'flex',
    justifyContent: 'center',
    paddingBottom: 1,
    height: 40,
    width: 40
  },
  locationContainer: {
    display: 'flex',
    flexWrap: 'wrap',
    justifyContent: 'center',
    margin: '0 auto',
    textAlign: 'center'
  },
  primaryInfoContainer: {
    marginTop: 0,
    paddingTop: 70,
    position: 'relative',
    bottom: 70
  },
  requiredText: {
    margin: '10px 0px'
  },
  sectionContainer: {
    marginTop: 60,
    paddingBottom: 25
  },
  sectionHeader: {
    alignSelf: 'flex-end',
    borderColor: colors.grey,
    fontSize: 24,
    flex: 1,
    marginLeft: 12
  },
  sectionHeaderContainer: {
    display: 'flex',
    marginBottom: 20
  },
  smallTitle: {
    display: 'block',
    fontSize: 18,
    fontWeight: 'bold',
    marginBottom: 20
  },
  summary: {
    minHeight: 130,
    height: '100%',
    minWidth: '100%',
    maxWidth: '100%'
  },
  summaryContainer: {
    flex: 1
  },
  summaryLabel: {
    fontWeight: 'bold'
  },
  summaryText: {
    minHeight: 150,
    margin: 'auto',
    width: isBrowser || isTablet ? '60%' : '100%'
  },
  summaryNote: {
    color: colors.darkgrey,
    fontSize: 13
  },
  transferButton: {
    bottom: 70,
    marginTop: 24,
    position: 'relative'
  },
  transferIcon: {
    fontSize: 16
  },
  wrapper: {
    margin: '0 auto',
    paddingBottom: 90,
    maxWidth: sizes.childScreen
  }
}

const mapStateToProps = (state) => ({})

const mapDispatchToProps = (dispatch) => ({
  clearFormArray: ({ key, indexes }) =>
    dispatch(
      Actions.clearFormArrayField({
        key,
        indexes,
        formId: FORM_ID
      })
    )
})

const wrappedForm = connect(mapStateToProps, mapDispatchToProps)(HomeEditForm)

export default Form(wrappedForm, FORM_ID)
